import "../App.css";
import React, { useState, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { DevTool } from "@hookform/devtools";
import Discount from "../assets/images/discount.png";
import Success from "../assets/images/Success.png";
import Apologize from "../assets/images/apologize.png";
// import dotenv from "react-dotenv";

const branch = "PRODUCTION";

const HOSTNAME =
  branch === "PRODUCTION"
    ? "https://paymentsbackend.1to1help.net"
    : "http://localhost:1337";

const PaymentForm = () => {
  const form = useForm();
  const {
    register,
    control,
    handleSubmit,
    formState,
    setValue,
    watch,
    setError,
  } = form;
  const { errors } = formState;
  const activeButtonValue = watch("activeButton", 3);
  const empCountValue = watch("empCount", 100);

  const billing = ["Quarterly", "Half-Yearly", "Annual"];
  const disallowedDomains = [
    "gmail.com",
    "hotmail.com",
    "yahoomail.com",
    "yahoo.co.in",
    "yahoo.com",
  ];
  const IndianStates = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Jammu and Kashmir",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Lakshadweep",
    "Delhi",
    "Puducherry",
  ];

  const [grossPayable, setGrossPayable] = useState(0);
  const [gstPayable, setGSTPayable] = useState(0);
  const [totalPayable, setTotalPayable] = useState(0);
  const [totalSavings, setTotalSavings] = useState(0);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailure, setShowFailure] = useState(false);

  useEffect(() => {
    // console.log("In scrollToForm useEffect");
    window.scrollTo(0, 160);
  }, []);

  const buttonClass = (buttonId) => {
    return buttonId === activeButtonValue ? "active" : "inactiveButton";
  };

  const handleEmpCodeValueChange = (e) => {
    const newEmpCount = e.target.value;

    if (newEmpCount === "" || newEmpCount <= 300)
      setValue("empCount", newEmpCount);
  };

  const isDisallowedEmail = (email) => {
    const domain = email.split("@")[1];
    return disallowedDomains.includes(domain);
  };

  const onSubmit = async (formData) => {
    console.log("In formsubmit");
    formData.billingCycle = billing[activeButtonValue - 1];
    formData.grossPayable = grossPayable;
    formData.gstPayable = gstPayable;
    formData.totalPayable = totalPayable;

    if (isDisallowedEmail(formData.email)) {
      setError("email", {
        type: "manual",
        message: "Please enter official email id",
      });
      return;
    }

    if (formData.country !== "India") {
      setError("country", {
        type: "manual",
        message: "Please enter country as India",
      });
      return;
    }

    //Send data to backend
    // console.log("Form submitted", formData);
    try {
      const response = await fetch(HOSTNAME + "/payment/save", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      console.log(data);

      showRazorPay(
        data._id,
        formData.fullname,
        formData.email,
        formData.mobile,
        formData.totalPayable
      );
    } catch (e) {
      console.log("Error: ", e);
    }
  };

  useEffect(() => {
    let monthlyFee = 9900;
    if (empCountValue > 100) {
      monthlyFee = empCountValue * 99;
    }
    if (activeButtonValue === 1) {
      let newGrossPayable = monthlyFee * 3;
      setGrossPayable(newGrossPayable);
      let newGSTPayable = (18 / 100) * newGrossPayable;
      setGSTPayable(parseFloat(newGSTPayable.toFixed(2)));
      let newTotalPayable =
        newGrossPayable + parseFloat(newGSTPayable.toFixed(2));
      setTotalPayable(newTotalPayable.toFixed(2));
      setTotalSavings(0);
    } else if (activeButtonValue === 2) {
      let newGrossPayable = monthlyFee * 6;
      setGrossPayable(newGrossPayable);
      let newGSTPayable = (18 / 100) * newGrossPayable;
      setGSTPayable(parseFloat(newGSTPayable.toFixed(2)));
      let newTotalPayable =
        newGrossPayable + parseFloat(newGSTPayable.toFixed(2));
      setTotalPayable(newTotalPayable.toFixed(2));
      const savingFee = monthlyFee / 2;
      const savingGST = (18 / 100) * savingFee;
      const savedAmount = savingFee + savingGST;
      setTotalSavings(savedAmount);
    } else if (activeButtonValue === 3) {
      let newGrossPayable = monthlyFee * 12;
      setGrossPayable(newGrossPayable);
      let newGSTPayable = (18 / 100) * newGrossPayable;
      setGSTPayable(parseFloat(newGSTPayable.toFixed(2)));
      let newTotalPayable =
        newGrossPayable + parseFloat(newGSTPayable.toFixed(2));
      setTotalPayable(newTotalPayable.toFixed(2));
      const savingFee = monthlyFee * 2;
      const savingGST = (18 / 100) * savingFee;
      const savedAmount = savingFee + savingGST;
      setTotalSavings(savedAmount);
    }
  }, [activeButtonValue, empCountValue]);

  const showRazorPay = async (
    savedMongoId,
    name,
    email,
    mobile,
    totalPayable
  ) => {
    try {
      const response = await fetch(HOSTNAME + "/payment/createorder", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          amount: totalPayable,
          id: savedMongoId,
        }),
      });
      if (response.ok) {
        const data = await response.json();
        console.log("In RPay options: ", data);
        var options = {
          key: "rzp_live_qW0VsCKvkAhDaL",
          amount: data.amount,
          currency: data.currency,
          name: "1to1help.net",
          description: "Payment to 1to1help",
          image:
            "https://d1lvcjuoszleku.cloudfront.net/assets/V_1/img/favicon-logo.png",
          order_id: data.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
          handler: function (response) {
            // alert(response.razorpay_payment_id);
            // alert(response.razorpay_order_id);
            // alert(response.razorpay_signature);
            if (
              typeof response.razorpay_payment_id == "undefined" ||
              response.razorpay_payment_id < 1
            ) {
              setShowFailure(true);
            } else {
              setShowSuccess(true);
            }
          },
          prefill: {
            //We recommend using the prefill parameter to auto-fill customer's contact information, especially their phone number
            name: name, //your customer's name
            email: email,
            contact: mobile, //Provide the customer's phone number for better conversion rates
          },
        };
        const paymentObj = new window.Razorpay(options);
        paymentObj.open();
      } else {
        throw new Error(
          JSON.stringify({
            code: response.status,
            message: response.statusText,
          })
        );
      }
    } catch (e) {
      console.log("Error: ", e);
    }
  };

  const checkKeyDown = (e) => {
    if (e.key === "Enter") e.preventDefault();
  };

  return (
    <>
      <div className="body-3">
        {showSuccess && (
          <section style={{ marginTop: "5%" }}>
            <div className="w-layout-blockcontainer w-container">
              <div className="w-row">
                <div className="w-col w-col-12">
                  <div
                    style={{
                      width: "100%",
                      padding: "20px 15px",
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                      float: "left",
                      boxShadow: "0 1px 18px 13px rgba(0, 123, 129, .04)",
                      marginTop: "30px",
                    }}
                  >
                    <img
                      src={Success}
                      alt="success"
                      style={{ width: "80%", margin: "30px auto" }}
                    />
                    <p style={{ width: "80%", margin: "0 auto" }}>
                      You will receive a confirmation email along with a virtual
                      contract for e-sign shortly. Please check your spam folder
                      as well if not found in inbox. Please reach out to our
                      customer support in case the email does not appear in your
                      inbox in the next 48 hours.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {showFailure && (
          <section style={{ marginTop: "5%" }}>
            <div className="w-layout-blockcontainer w-container">
              <div className="w-row">
                <div className="w-col w-col-12">
                  <div
                    style={{
                      width: "100%",
                      padding: "20px 15px",
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                      float: "left",
                      boxShadow: "0 1px 18px 13px rgba(0, 123, 129, .04)",
                      marginTop: "30px",
                    }}
                  >
                    <img
                      src={Apologize}
                      alt="apologize"
                      style={{ width: "80%", margin: "30px auto" }}
                    />
                    <p style={{ width: "80%", margin: "0 auto" }}>
                      We apologize for the inconvenience, but it seems that the
                      payment for your purchase was unsuccessful. There might be
                      various reasons for this issue Feel free to reach out to
                      our customer support via [contact details] for any
                      questions or concerns. Thank you for your understanding,
                      and we appreciate your patience.
                    </p>
                    <a
                      href="https://payments.1to1help.net"
                      class="button-14 w-button"
                      style={{
                        textAlign: "center",
                        padding: "10px 80px",
                        marginTop: "30px",
                        width: "max-content",
                      }}
                    >
                      Try again
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {!showSuccess && !showFailure && (
          <>
            <section
              className="section-28"
              style={{ backgroundColor: "#abeaed17" }}
            >
              <div
                className="div-block-35"
                style={{ borderRadius: "0 0 35px 35px", paddingTop: "35px" }}
              >
                <h1 className="heading-33" style={{ marginBottom: "10px" }}>
                  Order Summary
                </h1>
                <p style={{ marginBottom: "10px" }}>
                  *Get 2 months free on annual billing
                </p>
              </div>
            </section>

            <section
              className=""
              style={{
                padding: "20px",
                backgroundColor: "#abeaed17",
                paddingTop: "0",
                marginTop: "-40px",
              }}
            >
              <div className="main-container">
                <div className="w-row">
                  <form
                    className="ResponsiveForm widthfloat"
                    style={{ display: "flex" }}
                    onSubmit={handleSubmit(onSubmit)}
                    onKeyDown={(e) => checkKeyDown(e)}
                    noValidate
                  >
                    <div className="w-col w-col-6 widthfloat">
                      <div
                        style={{
                          padding: "20px 15px",
                          backgroundColor: "#fff",
                          borderRadius: "10px",
                          float: "left",
                          boxShadow: "0 1px 18px 13px rgba(0, 123, 129, .04)",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "18px",
                            fontWeight: "bold",
                            textAlign: "left",
                            marginBottom: "10px",
                          }}
                        >
                          Billing Details{" "}
                          <span
                            style={{
                              margin: "0",
                              fontSize: "14px",
                              textAlign: "right",
                              float: "right",
                              fontWeight: "400",
                            }}
                          >
                            * Required field
                          </span>
                        </p>

                        <div>
                          <input
                            type="text"
                            id="fullname"
                            name="fullname"
                            className="billingforminput"
                            placeholder="Full Name *"
                            {...register("fullname", {
                              required: "Please enter name",
                            })}
                          />
                          <p className="error">{errors.fullname?.message}</p>
                        </div>

                        <div>
                          <input
                            type="text"
                            id="company"
                            name="company"
                            className="billingforminput"
                            placeholder="Company *"
                            {...register("company", {
                              required: "Please enter Company",
                            })}
                          />
                          <p className="error">{errors.company?.message}</p>
                        </div>

                        <div>
                          <input
                            type="text"
                            id="email"
                            name="email"
                            className="billingforminput"
                            placeholder="Official Email Id *"
                            {...register("email", {
                              required: "Please enter official email id",
                              pattern: {
                                value:
                                  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                message: "Please enter valid email",
                              },
                            })}
                          />
                          <p className="error">{errors.email?.message}</p>
                        </div>

                        <div>
                          <input
                            type="text"
                            id="mobile"
                            name="mobile"
                            className="billingforminput"
                            placeholder="Mobile *"
                            {...register("mobile", {
                              required: "Please enter mobile number",
                              pattern: {
                                value: /^\+?\d{10}$/,
                                message: "Please enter valid mobile number",
                              },
                            })}
                          />
                          <p className="error">{errors.mobile?.message}</p>
                        </div>

                        <div style={{ width: "49%", float: "left" }}>
                          <input
                            type="text"
                            id="address"
                            name="address"
                            className="billingforminput"
                            placeholder="Registered Address *"
                            {...register("address", {
                              required: "Please enter Address",
                            })}
                          />
                          <p className="error">{errors.address?.message}</p>
                        </div>

                        <div style={{ width: "49%", float: "right" }}>
                          <input
                            type="text"
                            id="city"
                            name="city"
                            className="billingforminput"
                            placeholder="City *"
                            {...register("city", {
                              required: "Please enter City",
                            })}
                          />
                          <p className="error">{errors.city?.message}</p>
                        </div>

                        <div className="w-row">
                          <div
                            className="w-col w-col-6"
                            style={{ padding: "0px", paddingRight: "1%" }}
                          >
                            <select
                              name="state"
                              id="state"
                              className="billingforminput"
                              {...register("state", {
                                required: "Please enter State",
                              })}
                            >
                              <option value="">State *</option>
                              {IndianStates.map((state) => (
                                <option key={state} value={state}>
                                  {state}
                                </option>
                              ))}
                            </select>
                            <p className="error">{errors.state?.message}</p>
                          </div>

                          <div
                            className="w-col w-col-6"
                            style={{ padding: "0px", paddingLeft: "1%" }}
                          >
                            <input
                              type="text"
                              id="country"
                              name="country"
                              className="billingforminput"
                              placeholder="Country *"
                              value={"India"}
                              {...register("country", {
                                required: "Please enter Country",
                              })}
                            />
                            <p className="error">{errors.country?.message}</p>
                          </div>
                        </div>

                        <div style={{ width: "49%", float: "left" }}>
                          <input
                            type="text"
                            id="zip"
                            name="zip"
                            className="billingforminput"
                            placeholder="Zip Code *"
                            {...register("zip", {
                              required: "Please enter Zipcode",
                            })}
                          />
                          <p className="error">{errors.zip?.message}</p>
                        </div>

                        <div style={{ width: "49%", float: "right" }}>
                          <input
                            type="text"
                            id="gst"
                            name="gst"
                            className="billingforminput"
                            placeholder="GSTIN *"
                            {...register("gst", {
                              required: "Please enter GST",
                              minLength: {
                                value: 15,
                                message: "Please enter valid GST",
                              },
                            })}
                          />
                          <p className="error">{errors.gst?.message}</p>
                        </div>
                      </div>
                    </div>

                    <div className="w-col w-col-6 ResponsiveMarginTop widthfloat">
                      <div
                        style={{
                          padding: "20px 15px",
                          backgroundColor: "#fff",
                          borderRadius: "10px",
                          float: "left",
                          boxShadow: "0 1px 18px 13px rgba(0, 123, 129, .04)",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <div>
                          <div
                            className="div-block-36"
                            style={{ padding: "0 10px", borderBottom: "0" }}
                          >
                            <div className="w-row">
                              <p
                                style={{
                                  fontSize: "18px",
                                  fontWeight: "bold",
                                  textAlign: "left",
                                  marginBottom: "10px",
                                }}
                              >
                                Billing
                                {activeButtonValue === 2 && (
                                  <span
                                    style={{
                                      fontSize: "16px",
                                      color: "#0fdf0f",
                                      float: "right",
                                      fontWeight: "400",
                                    }}
                                  >
                                    <span
                                      style={{ textDecoration: "line-through" }}
                                    >
                                      180
                                    </span>{" "}
                                    195 days
                                  </span>
                                )}
                                {activeButtonValue === 3 && (
                                  <span
                                    style={{
                                      fontSize: "16px",
                                      color: "#0fdf0f",
                                      float: "right",
                                      fontWeight: "400",
                                    }}
                                  >
                                    <span
                                      style={{ textDecoration: "line-through" }}
                                    >
                                      12
                                    </span>{" "}
                                    14 Months
                                  </span>
                                )}
                              </p>
                            </div>
                          </div>

                          <div
                            className="billingCycle"
                            style={{
                              padding: "5px",
                              boxShadow: "0 0 13px #00000014",
                              borderRadius: "14px",
                            }}
                          >
                            <Controller
                              name="activeButton"
                              control={control}
                              defaultValue={3}
                              render={({ field }) => (
                                <>
                                  <button
                                    type="button"
                                    className={`button-141 w-button ${buttonClass(
                                      1
                                    )}`}
                                    onClick={() => {
                                      field.onChange(1);
                                      setValue("activeButton", 1);
                                    }}
                                  >
                                    Quarterly
                                  </button>
                                  <button
                                    type="button"
                                    className={`button-141 w-button ${buttonClass(
                                      2
                                    )}`}
                                    onClick={() => {
                                      field.onChange(2);
                                      setValue("activeButton", 2);
                                    }}
                                  >
                                    Half-Yearly
                                  </button>
                                  <button
                                    type="button"
                                    className={`button-141 w-button ${buttonClass(
                                      3
                                    )}`}
                                    onClick={() => {
                                      field.onChange(3);
                                      setValue("activeButton", 3);
                                    }}
                                  >
                                    Annually
                                  </button>
                                </>
                              )}
                            />
                          </div>

                          <div className="w-row" style={{ padding: "0 10px" }}>
                            <div
                              className="w-col w-col-4"
                              style={{ padding: "0px" }}
                            >
                              <label
                                htmlFor="empCount"
                                className="paragraph-84"
                                style={{ textAlign: "left" }}
                              >
                                EAP Essentials
                              </label>
                              <p
                                className="paragraph-86"
                                style={{
                                  textAlign: "left",
                                  fontSize: "14px",
                                  margin: "0",
                                }}
                              >
                                For 1 - 300 Employees
                              </p>
                            </div>
                            <div
                              className="w-col w-col-8"
                              style={{ padding: "0px" }}
                            >
                              <Controller
                                name="empCount"
                                control={control}
                                defaultValue={empCountValue} // Default value
                                rules={{
                                  required: "Please enter Employee Count", // Add required rule
                                  max: 300, // Set the maximum allowed value
                                }}
                                render={({ field }) => (
                                  <>
                                    <input
                                      type="number" // Use type "number" to ensure you get numeric input
                                      {...field}
                                      style={{
                                        padding: "10px",
                                        border: "1px solid #CECECE",
                                        borderRadius: "7px",
                                        width: "100%",
                                        height: "45px",
                                        marginTop: "7px",
                                      }}
                                      placeholder="Employee Count"
                                      onChange={handleEmpCodeValueChange}
                                      max={300} // Set the maximum allowed value
                                    />
                                    {errors.empCount && (
                                      <p className="error">
                                        {errors.empCount.message}
                                      </p>
                                    )}
                                  </>
                                )}
                              />
                              <br />
                              <span
                                style={{
                                  fontSize: "14px",
                                  color: "green",
                                  float: "right",
                                }}
                              >
                                <a
                                  href="https://1to1help.net/#requestademo"
                                  style={{
                                    color: "#2ECBD3",
                                    textDecoration: "underline",
                                  }}
                                >
                                  Click here for 300+ employees
                                </a>
                              </span>
                            </div>
                          </div>
                          <div className="w-row billingRow">
                            <div className="w-col w-col-12">
                              <p
                                className="paragraph-86"
                                style={{ textAlign: "left" }}
                              >
                                Gross Payable{" "}
                                <span
                                  style={{ fontWeight: "bold", float: "right" }}
                                >
                                  &#8377; {grossPayable}
                                </span>
                              </p>
                              <p
                                className="paragraph-86"
                                style={{ textAlign: "left", margin: "0" }}
                              >
                                GST{" "}
                                <span
                                  style={{ fontWeight: "bold", float: "right" }}
                                >
                                  &#8377; {gstPayable}
                                </span>
                              </p>
                              <h1
                                className="paragraph-86"
                                style={{
                                  textAlign: "left",
                                  margin: "0",
                                  fontFamily: "Titillium Web, sans-serif",
                                }}
                              >
                                <b>Total Payable </b>
                                <span
                                  className="heading-33"
                                  style={{
                                    float: "right",
                                    fontSize: "30px",
                                    textAlign: "center",
                                    color: "#2ECBD3",
                                    marginBottom: "5px",
                                  }}
                                >
                                  &#8377; {totalPayable}
                                </span>
                              </h1>

                              {totalSavings > 0 && (
                                <div
                                  style={{
                                    padding: "5px",
                                    backgroundColor: "#f4433617",
                                    borderRadius: "10px",
                                    marginBottom: "13px",
                                  }}
                                >
                                  <span>
                                    <img
                                      src={Discount}
                                      alt="discount"
                                      style={{
                                        width: "20px",
                                        marginRight: "10px",
                                        marginTop: "-4px",
                                      }}
                                    />
                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        color: "#f44336",
                                      }}
                                    >
                                      &#8377;{totalSavings}{" "}
                                    </span>
                                    &nbsp; Saved on{" "}
                                    {billing[activeButtonValue - 1]} billing
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="w-row">
                            <div
                              className="w-col w-col-12"
                              style={{ padding: "0 10px" }}
                            >
                              <button
                                className="button-14 w-button"
                                style={{
                                  width: "100%",
                                  textAlign: "center",
                                  margin: "10px 0",
                                }}
                                onClick={showRazorPay}
                              >
                                Proceed
                              </button>
                              <label
                                htmlFor="terms"
                                style={{
                                  fontSize: "15px",
                                  fontWeight: "500",

                                  textAlign: "left",
                                }}
                              >
                                By clicking 'Proceed', you acknowledge that you
                                have read and accepted our <br />
                                <a href="https://1to1help.net/terms-and-conditions/">
                                  Terms and Conditions
                                </a>
                                , and you are fully aware of and consent to our{" "}
                                <a href="https://1to1help.net/privacy-policy/">
                                  Privacy Policy
                                </a>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </section>
          </>
        )}
      </div>

      <DevTool control={control} />
    </>
  );
};

export default PaymentForm;
